import { __assign, __rest } from "tslib";
import React from 'react';
import { StyledSpinner } from './spinner.styled';
export var Spinner = function (_a) {
    var _b = _a.ariaLabel, ariaLabel = _b === void 0 ? 'Loading...' : _b, className = _a.className, _c = _a.fullScreen, fullScreen = _c === void 0 ? false : _c, attributes = _a.attributes, otherHTMLProperties = __rest(_a, ["ariaLabel", "className", "fullScreen", "attributes"]);
    return (React.createElement(StyledSpinner, __assign({ role: "status", ariaLabel: ariaLabel, fullScreen: fullScreen, className: className }, attributes, otherHTMLProperties),
        React.createElement("i", { className: "icon-svg" },
            React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg" },
                React.createElement("path", { opacity: ".25", d: "M16 0a16 16 0 0 0 0 32 16 16 0 0 0 0-32m0 4a12 12 0 0 1 0 24 12 12 0 0 1 0-24" }),
                React.createElement("path", { d: "M16 0a16 16 0 0 1 16 16h-4A12 12 0 0 0 16 4z" })))));
};
export default Spinner;
